import api from '../services/api';

const Especie = {
  create : async function (data) {
    return await api.post('especies', data)
    .then(response=>response)
    .catch(error=>error);
  },

  delete : async function (especie_id) {
    return await api.delete(`especies/id/${especie_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Um item pelo id (usado pelas páginas de edição do painel administrativo).
  findById : async function (id) {
    return await api.get(`especies/id/${id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Listagem paginada com busca opcional (usada pelas listas do painel administrativo).
  listar : async function (page = 1, limit = 10, busca = '') {
    const termo = (busca || '').trim();
    const url = termo
      ? `especies/data/${encodeURIComponent(termo)}/${page}/${limit}`
      : `especies/all/${page}/${limit}`;
    return await api.get(url)
    .then(response=>response)
    .catch(error=>error);
  },
  findAll : async function () {
    return await api.get('especies/all/1/6')
    .then(response=>response)
    .catch(error=>error);
  },

  findSearch : async function (data) {
    return await api.get(`especies/data/${data}/1/20`)
    .then(response=>response)
    .catch(error=>error);
  }
}

export default Especie;
